// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"52":"REFUNDS","131":"SHOP","483":"NOT_FOUND","724":"TERMS","859":"CHECKOUT","940":"PRODUCT"}[chunkId] + ".css";
};